/* Copyright 2025 Supovia LLC */
import get from './get.js'

export default function getDocuments(parameters) {
  let url = 'documents'

  url += `?${new URLSearchParams(parameters).toString()}`

  return get({ url }).catch(error => {
    throw new Error(`Couldn't get documents : ${error}`, { cause: error })
  })
}
